'use client'

import { motion, useScroll, useMotionValueEvent } from 'framer-motion'
import { useState } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { LandingButton } from './landing-button'
import { Logo } from './logo'

const NAV_LINKS = [
    { href: '/', label: 'Dashboard' },
    { href: '/updates', label: 'Updates' },
    { href: '/ticker-store', label: 'Store' },
    { href: '/contact-us', label: 'Contact' },
]

export function LandingNav() {
    const [isVisible, setIsVisible] = useState(true)
    const pathname = usePathname()
    const { scrollY } = useScroll()

    // Optimized scroll handler with threshold to reduce state updates
    useMotionValueEvent(scrollY, 'change', (latest) => {
        const previous = scrollY.getPrevious()
        if (previous === undefined) return

        // Only update state when scroll difference is significant (>5px)
        const scrollDiff = Math.abs(latest - previous)
        if (scrollDiff < 5) return

        if (latest < previous) {
            setIsVisible(true)
        } else if (latest > previous && latest > 50) {
            setIsVisible(false)
        }
    })

    return (
        <motion.nav
            className="fixed left-1/2 -translate-x-1/2 w-[84.2%] max-w-[986px] bg-white/80 backdrop-blur-[30px] h-12.25 top-7.5 z-50 rounded-[40px] flex items-center justify-between p-2.5"
            initial={{ y: 0 }}
            animate={{ y: isVisible ? 0 : '-180%' }}
            transition={{
                duration: 0.3,
                ease: 'easeInOut',
            }}
        >
            <Logo href="/" />
            <div className="hidden md:block">
                <ul className="flex items-center gap-5">
                    {NAV_LINKS.map((link) => {
                        const isActive = pathname === link.href
                        return (
                            <li key={link.href}>
                                <Link
                                    href={link.href}
                                    className={`transition-colors font-medium text-xs ${
                                        isActive
                                            ? 'text-black/80 hover:text-black'
                                            : 'text-black/40 hover:text-black/80'
                                    }`}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </div>
            <div className="flex items-center gap-5">
                <Link href="/auth" className="hidden md:block" prefetch={false}>
                    <LandingButton variant="light-blue">Login</LandingButton>
                </Link>
                <Link href="/auth" prefetch={false}>
                    <LandingButton variant="blue">Try For Free</LandingButton>
                </Link>
            </div>
        </motion.nav>
    )
}
